export default {
    clients: {
        client: 'Клиент',
        clients: 'Клиенты',
        search: 'Поиск клиента по имени или телефону',
        data: 'Данные клиента',
        phone: 'Телефон клиента',
        name: 'Имя',
        email: 'Email',
        discount: 'Скидка',
        photo: 'Фото',
        documents: 'Документы',
        contraindications: 'Противопоказания',
        indications: 'Показания',
        anamnesis:'Анамнез',
        contraindicationsService: 'Противопоказанные услуги',
        indicationsService: 'Рекомендованные услуги',



        tasks: 'Задачи',
        addPhoto: 'Добавить фото',
        addDocument: 'Добавить документ',
        number: 'Номер абонемента',
    },
};
